import { render, staticRenderFns } from "./EditDistributorName.vue?vue&type=template&id=25d972b6"
import script from "./EditDistributorName.vue?vue&type=script&lang=js"
export * from "./EditDistributorName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports